import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=d5b5253c&scoped=true&"
var script = {}
import style0 from "./carousel.vue?vue&type=style&index=0&id=d5b5253c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b5253c",
  null
  
)

export default component.exports